import { render, staticRenderFns } from "./VipLevelIcon.vue?vue&type=template&id=44c8563a&"
import script from "./VipLevelIcon.vue?vue&type=script&lang=js&"
export * from "./VipLevelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports